var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound__contentContainer"},[_c('img',{staticClass:"notfound__logo",attrs:{"src":this.$resources.notfoundLogo}}),_c('img',{staticClass:"notfound__textImage",attrs:{"src":this.$resources.notfoundText}}),_c('p',[_vm._v(_vm._s(_vm.$t('pageNotFound')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }